angular.module('galilai.creator').factory('styleService', function($rootScope, fontsService, $timeout) {

    const BASE_SIZE = 350

    const FORCE_ENABLE_AUTO_FONT_SIZE = false
    const TITLE_HIGHLIGHT_SIZE = '6rem'
    const OVERFLOW_MAX_FACTOR = 0.7
    const OVERFLOW_FACTOR_ENABLED = true
    const VISUAL_ENABLED = true
    const ENABLE_ROTATION = false // Not used anymore
    const ENABLE_FONT_REPLACEMENT = true
    const DEFAULT_FONT_MAX_SIZE = 2
    const DEFAULT_FONT_MIN_SIZE = 0.8
    const BASE_REM = 16
    const DEFAULT_FONT_MIN_SIZE_FOR_PAINTABLE_TEXTS = 0.3 // in Rem = 0.3 * BASE_REM = 4.8px
    const ENSURE_MIN_LINE_HEIGHT = false // not needed anymore, need to review
    // Auto fit
    const INCREASE_STEP_RATIO = 0.01;
    const MAX_ITERATIONS_FONT = 50
    const AUTOFIT_TOLERANCE = {
        width: 0.1,
        height: 0.01
    }
    const ENABLE_AUTO_HYPHENATE = true
    const ENABLE_HIGHLIGHT_PX_TO_EM = true
    const DEBUG = false

    const BASE_THEME = getBaseTheme()

    const remToPx = (rem) => {
        // If contains px, return as is (parse to float)
        if (typeof rem == 'string' && rem.indexOf('px') != -1) {
            return parseFloat(rem)
        }
        rem = parseFloat(rem)
        return rem * BASE_REM
    }

    const pxToRem = (px) => {
        if (typeof px == 'string' && px.indexOf('rem') != -1) {
            return parseFloat(px)
        }
        if (typeof px == 'number') {
            return px
        }
        px = parseFloat(px)
        return px / BASE_REM
    }

    const addMissingUnit = (value) => {
        if (typeof value == 'number') {
            return value + 'rem'
        }
        // If string and contains px, return as is
        if (typeof value == 'string' && value.indexOf('px') != -1) {
            return value
        }
        if (typeof value == 'string' && value.indexOf('rem') != -1) {
            return value
        }
        return value + 'rem'
    }

    const convertFontFactor = function(suggestedFontSize, baseFontSize, kind) {
        try {
            let defaultFontSize = 0
            if (kind == 'h1') {
                defaultFontSize = BASE_THEME.defaults.titleSize
            } else {
                defaultFontSize = BASE_THEME.defaults.descriptionSize
            }
            suggestedFontSize = pxToRem(suggestedFontSize)
            baseFontSize = pxToRem(baseFontSize)

            let factor = suggestedFontSize / defaultFontSize

            let updated = baseFontSize * factor
            return updated + 'rem'
        } catch (e) {
            console.error('Error converting font factor', e)
        }

        return addMissingUnit(element.font.size)
    }

    const visualAvailableProps = [
        'top',
        'left',
        'width',
        'height',
        'rotate',
        'z-index',
        'display',
        'position',
        'opacity',
        'font-size',
        'font-family',
        'text-align',
        'color',
        'background-color',
        'line-height',
        'border-radius',
        'border',
        'border-width',
        'border-style',
        'border-color',
        'background-image',
        'background-size',
        'background-position',
        'background-repeat',
    ]

    const AVAILABLE_ATTRIBUTES = new Set([
        'aspect-ratio',
        'hyphens',
        'hyphenate-limit-chars',
        'clip-path',
        'display',
        'grid-template-columns',
        'grid-gap',
        'grid-column',
        'grid-row-start',
        'grid-row-end',
        'grid-row',
        'grid-column-start',
        'grid-column-end',
        'align-items',
        'align-self',
        'align-content',
        'justify-items',
        'justify-content',
        'font-size',
        'flex-direction',
        'flex',
        'filter',
        'border-width',
        'border-style',
        'border-color',
        'position',
        'margin-top',
        'margin-right',
        'margin-bottom',
        'margin-left',
        'padding-top',
        'padding-right',
        'padding-bottom',
        'padding-left',
        'text-align',
        'direction',
        'overflow',
        'max-height',
        'min-height',
        'word-wrap',
        'white-space',
        'text-shadow',
        'background-repeat',
        'background-size',
        'background-position',
        'clipPathUnits',
        'rotate',
        'flex-shrink',
        'list-style-type',
        'letter-spacing',
        'line-height',
        '-webkit-text-stroke',
        '-webkit-text-fill-color',
        //'border-radius', TMP
    ])

    function isMD5(str) {
        return /^[a-f0-9]{32}$/.test(str);
    }

    function resetVisibility(style, oldVisibility) {
        if (!oldVisibility) {
            delete style['visibility']
        } else {
            style['visibility'] = oldVisibility
        }
        $timeout(angular.noop);
    }

    function isDynamicFont(family) {
        // Split at first comma
        family = family.split(',')[0].trim()
        // Check if starts and ends with quotes and middle is MD5
        if (family.length < 34) {
            return false
        }
        if (family[0] != '"' || family[family.length - 1] != '"') {
            return false
        }
        let middle = family.substring(1, family.length - 1)
        return isMD5(middle)
    }

    // TODO - Rethink this
    function getLineHeightForPx(px) {
        if (px >= 50) return 1.0;      // very big headline
        if (px >= 40) return 1.1;      // big headline
        if (px >= 24) return 1.2;    // medium
        return 1.25;                  // smaller text
    }

    function convertFontSizesToEm(str) {
        if (!ENABLE_HIGHLIGHT_PX_TO_EM) {
            return str;
        }
        if (str.indexOf('number-highlight') != -1) {
            str = str.replace(/font-size:\s*([\d.]+)(em|rem)/gi, function(match, size, unit) {
                return 'font-size: 24px';
            });
            str = str.replace(/display:\s*block;?/gi, '');
        }
        else if (str.indexOf('<z') === -1) {
            return str; // nothing to do
        }
        return str.replace(/font-size:\s*([\d.]+)px/gi, function(match, pxValue) {
            var px = parseFloat(pxValue);
            var emValue = (px / BASE_REM).toFixed(4).replace(/0+$/, '').replace(/\.$/, '');
            var lh = getLineHeightForPx(px);
            return 'font-size: ' + emValue + 'em; line-height: ' + lh + ';';
        });
    }
    function autoHyphenate(str) {
        if (!ENABLE_AUTO_HYPHENATE) {
            return str;
        }
        if (str.indexOf('<z') === -1) {
            return str; // nothing to do
        }

        var elements = str.match(/<z[^>]*style="[^"]*"[^>]*>/g);
        var sizes = [];

        // 2. Extrai todos font-size num array
        // Extract all font-sizes into an array
        for (var i = 0; i < elements.length; i++) {
            var m = elements[i].match(/font-size:\s*([0-9.]+)em/);
            if (m) sizes.push(parseFloat(m[1]));
        }

        // If no font-sizes found, nothing to do
        if (sizes.length === 0) {
            return str;
        }

        // find the smallest font-size
        var smallest = Math.min.apply(Math, sizes);

        // Add hyphens:auto to those with font-size larger than the smallest
        var output = str.replace(/(<z[^>]*style=")([^"]*)(")/g, function(match, start, style, end) {
            var sizeMatch = style.match(/font-size:\s*([0-9.]+)em/);
            if (!sizeMatch) return match;

            var size = parseFloat(sizeMatch[1]);
            if (size > smallest) {
                // only add if not already present
                if (style.indexOf("hyphens: auto") === -1) {
                    style += ";hyphens: auto;";
                }
            }
            return start + style + end;
        });

        return output;
    }

    let amount = 0
    // TODO - Fonts must be loaded first to resize
    function adjustFontSizeToFit(text, options) {
        let { width, height, fontFamily, max = 200, min = 1, proportionLineHeight, textStyles } = options;
        if (DEBUG) {
            console.log('adjustFontSizeToFit:', text, 'into', width, 'x', height, 'max:', max, 'min:', min)
        }
        const tempDiv = document.createElement('div');
        document.body.appendChild(tempDiv);

        // Set the div to match the target dimensions and allow wrapping
        tempDiv.style.visibility = 'hidden';
        tempDiv.style.position = 'absolute';
        tempDiv.style.width = `${width}px`; // Max width to allow wrapping
        tempDiv.style.fontFamily = fontFamily;
        tempDiv.style.whiteSpace = 'normal'; // Allow wrapping
        tempDiv.style.overflow = 'hidden'; // Hide overflow to accurately measure
        tempDiv.classList.add('text-measurement'); // Add a class for styling if needed
        if (!OVERFLOW_FACTOR_ENABLED) {
            tempDiv.style.overflowWrap = 'break-word'; // Allow breaking words
        }
        for (var styleKey in textStyles) {
            tempDiv.style[styleKey] = textStyles[styleKey];
        }

        if (DEBUG) {
            tempDiv.style.visibility = 'visible';
            tempDiv.style.color = 'red';
            tempDiv.style.background = 'yellow';
            tempDiv.style['z-index'] = 10000000;
            tempDiv.style.top = amount + 'px';
            amount += 80
        }

        tempDiv.innerHTML = text;

        // Adapt font-size
        var widthTolerance = width * AUTOFIT_TOLERANCE.width;
        var heightTolerance = height * AUTOFIT_TOLERANCE.height;

        var originalFontSize = remToPx(tempDiv.style.fontSize) || (DEFAULT_FONT_MAX_SIZE * BASE_REM)
        if (DEBUG) {
            console.log('Original font size for text fitting:', text, originalFontSize)
        }
        currentFontSize = originalFontSize;
        tempDiv.style.fontSize = originalFontSize + 'px';

        if (tempDiv.scrollWidth > width + widthTolerance || tempDiv.scrollHeight > height + heightTolerance) {
            var minFontSize = min;
            var maxFontSize = max;
            var step = originalFontSize * INCREASE_STEP_RATIO;

            var maxIterations = MAX_ITERATIONS_FONT; // Safety limit
            var iteration = 0;

            if (DEBUG) {
                console.log('Adjusting font size for text:', text, 'Original size:', originalFontSize, 'Step:', step, 'size', width, 'height', height, 'scroll', tempDiv.scrollWidth, tempDiv.scrollHeight, 'maxFontSize:', maxFontSize, 'minFontSize:', minFontSize)
            }

            while ((maxFontSize - minFontSize) > step) {
                if (iteration++ >= maxIterations) {
                    if (DEBUG) {
                        console.warn('Max iterations reached while adjusting font size for:', text);
                    }
                    break;
                }

                var midFontSize = (minFontSize + maxFontSize) / 2;

                tempDiv.style.fontSize = midFontSize + 'px';
                tempDiv.style.lineHeight = (midFontSize * proportionLineHeight) + 'px';

                var fitsWidth = tempDiv.scrollWidth <= width + widthTolerance;
                var fitsHeight = tempDiv.scrollHeight <= height + heightTolerance;

                if (DEBUG) {
                    console.log('Iteration:', iteration, 'midFontSize:', midFontSize, 'fitsWidth:', fitsWidth, 'fitsHeight:', fitsHeight, 'scrollWidth:', tempDiv.scrollWidth, 'scrollHeight:', tempDiv.scrollHeight, 'minFontSize:', minFontSize, 'maxFontSize:', maxFontSize)
                }

                if (fitsWidth && fitsHeight) {
                    currentFontSize = midFontSize;
                    minFontSize = midFontSize + step;
                } else {
                    maxFontSize = midFontSize - step;
                }
            }

            if (DEBUG) {
                console.log('Final font size for text:', text, 'is', currentFontSize, 'px', 'amount of iterations:', iteration, 'maxFontSize:', maxFontSize, 'minFontSize:', minFontSize)
            }
            // Apply final font size
            tempDiv.style.fontSize = currentFontSize + 'px';
            tempDiv.style.lineHeight = (currentFontSize * proportionLineHeight) + 'px';
        }

        // Now apply the final fitting font size
        tempDiv.style.fontSize = currentFontSize + 'px';
        tempDiv.style.lineHeight = (currentFontSize * proportionLineHeight) + 'px';

        if (tempDiv.scrollWidth > tempDiv.clientWidth && OVERFLOW_FACTOR_ENABLED) {
            let overflowFactor = Math.max(OVERFLOW_MAX_FACTOR, tempDiv.clientWidth / tempDiv.scrollWidth)
            currentFontSize = currentFontSize * overflowFactor
        }
        if (!DEBUG) {
            document.body.removeChild(tempDiv); // Clean up after calculation
        }

        return currentFontSize;
    }

    function replaceColor(color, pallete) {

        if (color == 'contrast-text') {
            if (pallete.text == 'white') {
                return 'white'
            }
            if (pallete.text == 'black') {
                if (pallete.main[0] == '#') {
                    let main = pallete.main.substring(1)
                    let r = parseInt(main.substring(0, 2), 16)
                    let g = parseInt(main.substring(2, 4), 16)
                    let b = parseInt(main.substring(4, 6), 16)
                    let newR = Math.max(0, r - 50)
                    let newG = Math.max(0, g - 50)
                    let newB = Math.max(0, b - 50)
                    return '#' + newR.toString(16) + newG.toString(16) + newB.toString(16)
                }
                if (pallete.main.indexOf('hsl') != -1) {
                    let hsl = pallete.main.substring(4, pallete.main.length - 1)
                    let hslValues = hsl.split(',')
                    let h = parseInt(hslValues[0])
                    let s = parseInt(hslValues[1])
                    let l = parseInt(hslValues[2])
                    let newL = Math.max(0, l - 30)
                    return 'hsl(' + h + ',' + s + '%,' + newL + '%)'
                }
                return 'black'
            }
        }
        if (color == 'bw-highlight') {
            // TODO - Improve, instead of using black use the main color darker
            // Decide if should use color black or white based on brightness
            if (pallete.highlight[0] == '#') {
                let highlight = pallete.highlight.substring(1)
                let r = parseInt(highlight.substring(0, 2), 16)
                let g = parseInt(highlight.substring(2, 4), 16)
                let b = parseInt(highlight.substring(4, 6), 16)
                let brightness = (r * 299 + g * 587 + b * 114) / 1000
                if (brightness > 150) {
                    return 'black'
                }
                return 'white'
            }
        }
        if (color == 'main-dark') {
            if (pallete.main[0] == '#') {
                return makeColorDarker(pallete.main, 30)
            }
        }
        if (color == 'main-light') {
            if (pallete.main[0] == '#') {
                return makeColorLighter(pallete.main, 30)
            }
        }
        function compareBrightness(color1, color2) {
            if (color1[0] == '#' && color2[0] == '#') {
                let brightness1 = getHEXRelativeLuminance(color1)
                let brightness2 = getHEXRelativeLuminance(color2)
                return brightness1 - brightness2
            }
            return 0
        }
        if (color == 'auto-dark') {
            // Choose between text and main which is darker
            let main = pallete.main
            let text = pallete.text
            if (compareBrightness(main, text) < 0) {
                color = 'main'
            }
            else {
                color = 'text'
            }
        }
        if (color == 'auto-light') {
            // Choose between text and main which is lighter
            let main = pallete.main
            let text = pallete.text
            if (compareBrightness(main, text) < 0) {
                color = 'text'
            }
            else {
                color = 'main'
            }
        }
        if (color.indexOf('readable-') != -1) {
            let refColor = color.replace('readable-', '')
            let allColors = ['main', 'text', 'highlight'].filter(c => c != refColor)
            // Now choose the one with the highest constrast between ref and the remaining
            let ref = pallete[refColor]
            let best = null
            let bestContrast = -1
            for (let i = 0; i < allColors.length; i++) {
                let current = pallete[allColors[i]]
                let contrast = getContrastRatio(ref, current)
                if (contrast > bestContrast) {
                    best = allColors[i]
                    bestContrast = contrast
                }
            }
            // TODO - Improve default
            return pallete[best] || pallete['text']
        }

        return pallete[color] || color
    }

    const BROWSER_FONTS = [
        'Arial', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS',
        'Book Antiqua', 'Bookman Old Style',
        'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS',
        'Consolas', 'Courier', 'Courier New',
        'Garamond', 'Geneva',
        'Helvetica', 'Helvetica Neue',
        'Impact',
        'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode',
        'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MT Extra', 'MV Boli',
        'Palatino', 'Palatino Linotype',
        'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol',
        'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS',
        'Verdana'
    ]
    function replaceFont(font, fonts) {
        if (!font) {
            return null
        }
        if (BROWSER_FONTS.indexOf(font) != -1) {
            return {
                fontFamily: font,
                weight: 'normal'
                // LATER - add size here
            }
        }
        let fontName = ''
        let fontSize = null
        let fontWeight = 'normal'
        if (typeof font == 'object') {
            fontName = font.name
            fontWeight = font.weight || fontWeight
            fontWeight = font.size
        }
        if (!fontName || fontName == '') {
            if (fonts) {
                fontName = fonts[font] || fonts.primary || fonts.secondary || 'Sans-Serif'
            } else {
                Sentry.captureException('Fonts not defined', {
                    extra: {
                        font: font
                    }
                })
                fontName = 'Sans-Serif'
            }
        }

        if (fontName && fontName.indexOf('[Bold]') != -1) {
            fontName = fontName.replace('[Bold]', '')
            weight = 'bold'
        }

        if (fontName.indexOf('"') == -1 && fontName.indexOf("'") == -1) {
            fontName = `"${fontName}"`
        }

        return {
            fontFamily: fontName,
            weight: fontWeight,
            size: fontSize
        }
    }

    function extractAllPrimaryFonts(htmlString) {

        const fontRegex = /font-family:\s*([^;]+);?/gi;
        let match;
        let fonts = [];
        try {
            while ((match = fontRegex.exec(htmlString)) !== null) {
                let fontName = match[1].split(',')[0].trim().replace(/^["']|["']$/g, '');
                fonts.push(fontName);
            }
        } catch (e) {
            console.error('Error extracting fonts from HTML', e);
        }
        // Make unique
        fonts = [...new Set(fonts)];

        return fonts;
    }

    // This also replace SVG colors and text highlights
    function highlightText(value, extras, paintId) {
        let pallete = extras.pallete
        if (extras?.repaintedMap?.[paintId]) {
            pallete = extras.repaintedMap[paintId];
        }
        if (typeof value != 'string') {
            return value;
        }
        if (!value) {
            return value;
        }
        try {
            // Use same color as a the color of a replaced value (e.g. el_title => replace=title
            if (extras?.elementsColors) {
                for (let elColor in extras.elementsColors) {
                    let colors = ['black', 'white']
                    let color = extras.elementsColors[elColor]
                    if (colors.indexOf(color.toLowerCase()) == -1) {
                        if (!color) continue;
                        color = color.toUpperCase();
                        if (!color.startsWith('#')) {
                            color = '#' + color;
                        }
                    }
                    value = value.replace('#EL_' + elColor.toUpperCase(), color);
                }
            }
        } catch (e) {
            console.error('Error replacing element colors', e);
        }

        if (!value) {
            return value;
        }

        value += ''
        if (value.indexOf('#BWHIGHLIGHT') != -1) {
            value = value.replace(new RegExp('#BWHIGHLIGHT', 'g'), replaceColor('bw-highlight', pallete));
        }
        for (let colorKey in pallete) {
            let color = pallete[colorKey];
            value = value.replace(new RegExp('#' + colorKey.toUpperCase(), 'g'), color);
        }

        let otherColors = [
            'auto-dark',
            'auto-light',
        ]

        for (let i = 0; i < otherColors.length; i++) {
            let color = otherColors[i]
            value = value.replace(new RegExp('#' + color.toUpperCase(), 'g'), replaceColor(color, pallete));
        }
        if (value.indexOf('svgbox.net') != -1) {
            value = value.replace(/color\=#/g, 'color=')
        }

        let fonts = extractAllPrimaryFonts(value)
        fonts.forEach(font =>
            fontsService.loadCustomOrDefault(font, function() {})
        );

        return value;
    }

    function replaceCSSAttributes(style, element, extras, kind='filtered') {
        for (let key in element) {
            if (AVAILABLE_ATTRIBUTES.has(key) || kind == 'all') {
                if (key == 'grid-row' || key == 'grid-column') {
                    style[key] = element[key] + ''
                } else {
                    style[key] = element[key] + ''
                }
                // Fix clip-path to make it unique globally
                if (key == 'clip-path') {
                    let clipPath = element[key]
                    let regex = /url\("#(.*?)"\)/g
                    let match = regex.exec(clipPath)
                    if (match && match.length > 1) {
                        let clipId = match[1]
                        style[key] = clipPath.replace(clipId, extras.renderedId + '-' + clipId)
                    }
                }
                // Disable
                if (key == 'aspect-ratio' && element.computed) {
                    try {
                        style.width = parseFloat(element[key]) * BASE_SIZE * extras.size.height + 'px';
                    } catch (e) {
                        console.error('Invalid aspect ratio', element[key])
                    }
                }
            }
        }
        return style
    }

    function applyContentFlexStyles(element, style) {
        if (element.type == 'container') {
            return
        }
        if (element.vpos == 'top') {
            style.alignItems = 'flex-start';
        }
        if (element.vpos == 'bottom') {
            style.alignItems = 'flex-end';
        }
        if (element.vpos == 'center') {
            style.alignItems = 'center';
        }
        if (element.hpos == 'left') {
            style.justifyContent = 'flex-start';
        }
        if (element.hpos == 'right') {
            style.justifyContent = 'flex-end';
        }
        if (element.hpos == 'center') {
            style.justifyContent = 'center';
        }
    }

    function autoShrinkText(style, element, minFontSize=DEFAULT_FONT_MIN_SIZE) {
        if (!isValidNumber(minFontSize)) {
            minFontSize = DEFAULT_FONT_MIN_SIZE
        }
        let text = element.replacedValue;
        if (!text) {
            return;
        }
        // TODO - Hardcoded
        text += ''
        // TODO - Allow px?
        if (style.fontSize.indexOf('rem') == -1) {
            return;
        }
        if (!element.replacedValue){
            return;
        }
        text = text.stripHtml()

        let cutoff = 50
        let rate = 0.5

        if (element && element.font && element.font.cutoff) {
            cutoff = element.font.cutoff
        }
        if (element && element.font && element.font.minSize) {
            minFontSize = element.font.minSize
        }
        if (element && element.font && element.font.rate) {
            rate = element.font.rate
        }
        if (text.length < cutoff) {
            return;
        }
        let currentFont = parseFloat(style.fontSize);

        let decreaseRate = rate * (text.length - cutoff) / cutoff
        let newFont = currentFont - decreaseRate
        // Check if font is too small
        if (newFont < minFontSize) {
            newFont = minFontSize
        }
        style.fontSize = newFont + 'rem'
    }

    function generate(element, depth, extras, uniqueId = null, newElement) {
        let style = {};

        let minFontSize = DEFAULT_FONT_MIN_SIZE
        // Element specific config
        if (element.type == 'container') {
            style.display = 'flex';
            style.flexDirection = 'column';
            style.position = 'relative';
            if (element.vpos == 'top') {
                style.justifyContent = 'flex-start';
            }
            if (element.vpos == 'bottom') {
                style.justifyContent = 'flex-end';
            }
            if (element.vpos == 'center') {
                style.justifyContent = 'center';
            }
            if (element.hpos == 'left') {
                style.alignItems = 'flex-start';
            }
            if (element.hpos == 'right') {
                style.alignItems = 'flex-end';
            }
            if (element.hpos == 'center') {
                style.alignItems = 'center';
            }

            // TODO - this is buggy
            /*
            if (element.draggable || typeof element.draggable == 'undefined') {
                style["pointer-events"] = 'all'
            } else {
                style["pointer-events"] = 'none'
            }*/
            style["pointer-events"] = 'none'
        }
        if (element.type == 'rect') {
            style.position = 'absolute';
        }
        if (element.type == 'trapezoid') {
            if (!element.base || !element.base.bottom || !element.base.top || !element.base.position) {
                console.error('Invalid trapezoid config', element);
                return
            }
            let mainHeight = BASE_SIZE * extras.size.height;
            let topSize = element.base.bottom - element.base.top;

            let positionV = topSize <= 0 ? 'top' : 'bottom'
            let positionH = element.base.position
            let trapezoidWidth = topSize <= 0 ? element.base.top : element.base.bottom
            if (topSize < 0) {
                topSize = topSize * -1
            }

            style['border-' + positionV] = mainHeight + 'px solid ' + replaceColor(element.background, extras.pallete);
            style['border-' + positionH] = topSize + 'px solid transparent';

            style.width = trapezoidWidth + 'px'
            style.background = 'none';
        }
        if (element.type == 'overlay') {
            style.display = 'flex';
        }
        applyContentFlexStyles(element, style);
        if (element.color) {
            style.color = replaceColor(element.color, extras.pallete);
        }
        let currentFontName = null
        if (element.font && element.font.name) {
            currentFontName = element.font.name
        }
        // TODO - Review
        if (element.type == 'h1' || element.type == 'p') {
            // style.overflowWrap = 'break-word';
        }
        if (element.type == 'h1') {
            let fontConfig = replaceFont(currentFontName || 'primary', extras.fonts);
            style.fontFamily = fontConfig.fontFamily;
            style.fontWeight = fontConfig.weight;
            if (extras.defaults && extras.defaults.titleSize) {
                style.fontSize = extras.defaults.titleSize + 'rem';
            }
            if (extras.custom && extras.custom.titleSize) {
                style.fontSize = extras.custom.titleSize + 'rem';
            }
            if (extras.custom && extras.custom.titleAlign) {
                style.textAlign = extras.custom.titleAlign;
            }
            if (extras.custom && extras.defaults.titleMinSize) {
                minFontSize = extras.defaults.titleMinSize || DEFAULT_FONT_MIN_SIZE
            }
            if (extras.custom && extras.custom.titleMinSize) {
                minFontSize = extras.custom.titleMinSize || DEFAULT_FONT_MIN_SIZE
            }
        }

        if (element.type == 'p' || element.type == 'span') {
            let fontConfig = replaceFont(currentFontName || 'secondary', extras.fonts);
            style.fontFamily = fontConfig.fontFamily;
            style.fontWeight = fontConfig.weight;
            style.whiteSpace = 'pre-wrap';
            if (extras.defaults && extras.defaults.descriptionSize) {
                style.fontSize = extras.defaults.descriptionSize + 'rem';
            }
            if (extras.info && extras.info.descriptionOnly) {
                style.fontSize = '1.2rem';
            }
            if (extras.custom && extras.custom.descriptionSize) {
                style.fontSize = extras.custom.descriptionSize + 'rem';
            }
            if (extras.custom && extras.custom.descriptionAlign) {
                style.textAlign = extras.custom.descriptionAlign;
            }
            if (extras.custom && extras.defaults.descriptionMinSize) {
                minFontSize = extras.defaults.descriptionMinSize || DEFAULT_FONT_MIN_SIZE
            }
            if (extras.custom && extras.custom.descriptionMinSize) {
                minFontSize = extras.custom.descriptionMinSize || DEFAULT_FONT_MIN_SIZE
            }
        }
        if (typeof element.font == 'object') {
            if (element.font.name) {
                let fontConfig = replaceFont(element.font.name, extras.fonts);
                style.fontFamily = fontConfig.fontFamily;
                style.fontWeight = fontConfig.weight;
            }
            if (element.font.size) {
                if (style.fontSize && element.font.size) {
                    style.fontSize = convertFontFactor(element.font.size, style.fontSize, element.type)
                } else {
                    style.fontSize = addMissingUnit(element.font.size)
                }
            }
            if (element.font.weight) {
                style.fontWeight = element.font.weight;
            }
        }
        if (element['line-height']) {
            style.lineHeight = element['line-height'];
        }

        // If is image, set background and use aspect fit cover
        if (element.type == 'image' && !element.content) {
            style.background = 'url(' + element.src + ')';
            if (element.aspect == 'contain') {
                style.backgroundSize = 'contain';
                style.backgroundPosition = 'center';
                style.backgroundRepeat = 'no-repeat';
                // Add background padding
                if (element.padding) {
                    style.backgroundOrigin = 'content-box';
                }
            } else {
                style.backgroundSize = 'cover';
                style.backgroundPosition = 'center';
            }
        }
        if (element.type == 'icon') {
            style.background = 'url(' + element.src + ')';
            style.backgroundSize = 'contain';
            style.backgroundPosition = 'center';
            style.backgroundRepeat = 'no-repeat';
        }

        let shouldShowOverlay = true
        if (extras && extras.defaults && typeof extras.defaults.hideOverlay != 'undefined') {
            shouldShowOverlay = !extras.defaults.hideOverlay
        }
        if (extras.custom && typeof extras.custom.hideOverlay != 'undefined') {
            shouldShowOverlay = !extras.custom.hideOverlay
        }
        if (element.overlay && element.src && element.overlay != 'none' && shouldShowOverlay) {
            // TASK [HP] - Review best type of overlay color
            let darkerMain = replaceColor('auto-dark', extras.pallete)
            let luminanceMain = getHEXRelativeLuminance(darkerMain)
            let overlayBegin = element.overlay
            let overlayEnd = darkerMain
            if (luminanceMain > 0.6) {
                let opacityOverlay = 0.8
                const { red, green, blue } = hexToRgb(darkerMain)
                overlayBegin = `rgba(${red}, ${green}, ${blue}, ${opacityOverlay})`
                overlayEnd = `rgba(${red}, ${green}, ${blue}, ${opacityOverlay})`
            }
            if (element.borderRadius || element.border) {
                style.background = 'linear-gradient(' + overlayBegin + ', ' + overlayEnd + '), ' + style.background;
            } else {
                style['gradient'] = {
                    'position': 'absolute',
                    'top': '0',
                    'left': '0',
                    'width': '100%',
                    'height': '100%',
                    'background': `linear-gradient(to bottom, ${overlayBegin} 0%, ${overlayEnd} 99%, ${overlayEnd} 100%)`,
                    'z-index': '1',
                    'pointer-events': 'none'
                }
                // Create a div with the style above (not the object)
                let styleSubElement = ''
                for (let key in style['gradient']) {
                    styleSubElement += key + ':' + style['gradient'][key] + ';'
                }
                element.content = `<div style="${styleSubElement}"></div>`
            }
        }

        if (element['box-shadow']) {
            style.boxShadow = element['box-shadow'];
        }

        if (element.aspect == 'square') {
            style['aspect-ratio'] = '1 / 1';
        }

        // Generic config
        if (element.align && !style.textAlign) {
            style.textAlign = element.align;
        }

        if (element.size == 'full') {
            style.width = '100%';
            style.height = '100%';
        }
        if (element.size == 'half') {
            style.width = '100%';
            style.height = '50%';
        }
        if (element.width == 'half') {
            style.width = '50%';
        }
        if (element.height == 'half') {
            style.height = '50%';
        }
        if (element.width == 'full') {
            style.width = '100%';
        }
        if (element.height == 'full') {
            style.height = '100%';
        }
        if (element.direction) {
            style.flexDirection = element.direction;
        }
        // LATER - improve
        if (element.right) {
            style.right = element.right;
        }
        if (element.left) {
            style.left = element.left;
        }
        if (element.top) {
            style.top = element.top;
        }
        if (element.bottom) {
            style.bottom = element.bottom;
        }
        if (element.id == 'main') {
            if (extras && extras.size) {
                style.width = BASE_SIZE * extras.size.width + 'px';
                style.height = BASE_SIZE * extras.size.height + 'px';
            } else if (extras && extras.canvasSize) {
                style.width = extras.canvasSize;
                style.height = extras.canvasSize;
            } else {
                style.width = BASE_SIZE + 'px';
                style.height = BASE_SIZE + 'px';
            }
            style.overflow = 'hidden';
        }
        if (element.width == 'auto') {
            style.width = 'auto';
        }
        if (element.height == 'auto') {
            style.height = 'auto';
        }
        if (element.width && element.width.indexOf('px') > -1) {
            style.width = element.width;
        }
        if (element.height && element.height.indexOf('px') > -1) {
            style.height = element.height;
        }
        if (element.width && element.width.indexOf('%') > -1) {
            style.width = element.width;
        }
        if (element.height && element.height.indexOf('%') > -1) {
            style.height = element.height;
        }
        if (element.position) {
            style.position = element.position;
        }
        let paddingMap = {
            'small': '10px',
            'medium': '20px',
            'large': '30px',
        }
        if (element.padding) {
            style.padding = paddingMap[element.padding] || element.padding;
        }
        if (element.margin) {
            style.margin = paddingMap[element.margin] || element.margin;
        }
        if (element.outline) {
            for (let outlineKey in element.outline) {
                let value = element.outline[outlineKey];
                if (outlineKey == 'color') {
                    value = replaceColor(value, extras.pallete);
                }
                style['outline-' + outlineKey] = value
            }
        }
        if (element.display) {
            style.display = element.display;
        }
        // TASK - improve verification
        if (element.background && element.type != 'trapezoid') {
            style.background = replaceColor(element.background, extras.pallete);

            if (element.overlay) {
                // TODO - Duplicated
                let darkerMain = replaceColor('auto-dark', extras.pallete)
                let luminanceMain = getHEXRelativeLuminance(darkerMain)
                let overlayBegin = element.overlay
                let overlayEnd = darkerMain
                if (luminanceMain > 0.6) {
                    let opacityOverlay = 0.8
                    const { red, green, blue } = hexToRgb(darkerMain)
                    overlayBegin = `rgba(${red}, ${green}, ${blue}, ${opacityOverlay})`
                    overlayEnd = `rgba(${red}, ${green}, ${blue}, ${opacityOverlay})`
                }
                style.background = 'linear-gradient(' + overlayBegin + ', ' + overlayEnd + ')'
            }
        }

        if (isValidNumber(element.opacity)) {
            style.opacity = getValidNumber(element.opacity);
        }
        // Bug - Overriding transform
        if (element.rotate) {
            style.transform = 'rotate(' + element.rotate + 'deg)';
        }
        if (element.transform) {
            style.transform = element.transform;
        }
        if (element.transformOrigin) {
            style.transformOrigin = element.transformOrigin;
        }
        if (element.borderRadius) {
            style.borderRadius = element.borderRadius;
        }
        if (typeof element.border == 'object') {
            for (let borderKey in element.border) {
                let value = element.border[borderKey];
                if (borderKey == 'color') {
                    value = replaceColor(value, extras.pallete);
                }
                style['border-' + borderKey] = value
            }
        }

        if (typeof element.border == 'outline') {
            for (let borderKey in element.border) {
                let value = element.border[borderKey];
                if (borderKey == 'color') {
                    value = replaceColor(value, extras.pallete);
                }
                style['outline-' + borderKey] = value
            }
        }

        // TASK [HP] - Improve
        let isWhiteMain = extras.pallete.main == 'white' || extras.pallete.main == '#ffffff' || extras.pallete.main == '#fff';
        if (element.id == 'gradient' && isWhiteMain) {
            style.background = 'none';
        }
        // LATER - hack for exporting
        if (element.type == 'rect') {
            style.zIndex = depth - 1
        } else {
            style.zIndex = depth
        }
        if (element.zIndex) {
            style.zIndex = element.zIndex;
        }

        function applyFilters() {
            if (!extras || !extras.originalLayout || !extras.originalLayout.pallete || !extras.originalLayout.pallete.main) {
                return
            }
            // Rotate colors
            let isImage = element.src && (element.src.indexOf('.jpeg') != -1 || element.src.indexOf('.jpg') != -1 || element.src.indexOf('.png') != -1);
            if (element.type != 'container' && (!element.src || !isImage) && element.type != 'p') {
                let hue = extras.originalLayout.transformation.hue
                let saturate = extras.originalLayout.transformation.saturate
                style.filter = 'hue-rotate(' + hue + 'deg) saturate(' + saturate + ')'
            }
        }
        applyFilters()

        function applyBrandKit(element, extras) {
            if (!extras || !extras.brandKit) {
                return
            }
            function convertToHEX(color) {
                color = color.split(')')[0]
                let rgb = color.match(/\d+/g)
                if (rgb) {
                    let hex = RGBToHEX(...rgb)
                    return hex
                }
                return null
            }
            function mapColor(color) {
                if (color && color.startsWith('#')) {
                    const { red, green, blue } = hexToRgb(color)
                    color = `rgba(${red}, ${green}, ${blue})`
                }
                if (color.indexOf('rgb') == -1) {
                    return color
                }
                let hex = convertToHEX(color)
                if (hex) {
                    let colorMapping = getColorMapping(hex)
                    if (colorMapping && transformColor(colorMapping)) {
                        return transformColor(colorMapping)
                    }
                }
                return color
            }

            function updateStyleAttributes(content) {
                const regexDouble = /style="([^"]*)"/g;
                const regexSingle = /style='([^']*)'/g;
                const regexes = [regexDouble, regexSingle];
                let match;
                let updatedContent = content;

                const replaceAttrs = ['fill', 'stroke', 'stop-color', 'color']

                for (let regex of regexes) {
                    while ((match = regex.exec(content)) !== null) {
                        if (match.length > 1) {
                            // Clip path bug svg
                            if (match[0].indexOf('url(') != -1) {
                                continue
                            }
                            let styles = match[1].split(';');
                            let attrs = {};

                            // Extract styles into attrs
                            for (let style of styles) {
                                let styleParts = style.split(':');
                                if (styleParts.length == 2) {
                                    attrs[styleParts[0].trim()] = styleParts[1].trim();
                                }
                            }

                            // Modify specific SVG attributes
                            for (let attr of replaceAttrs) {
                                if (attrs[attr]) {
                                    attrs[attr] = mapColor(attrs[attr]); // Ensure mapColor function is defined
                                }
                            }

                            // Construct new style string
                            let newStyle = 'style="';
                            for (let key in attrs) {
                                newStyle += key + ':' + attrs[key] + ';';
                            }
                            newStyle += '"';
                            // Replace the original style string in the content
                            updatedContent = updatedContent.replace(match[0], newStyle);
                        }
                    }
                }
                // Map direct colors attrs
                for (let color of replaceAttrs) {
                    let regex = new RegExp(color + '="(.*?)"', 'g')
                    let match;
                    while ((match = regex.exec(updatedContent)) !== null) {
                        if (match.length > 1) {
                            let newColor = mapColor(match[1])
                            updatedContent = updatedContent.replace(match[0], color + '="' + newColor + '"')
                        }
                    }
                }

                return updatedContent;
            }

            function extractColor(attr) {
                // extract rgb(255, 255, 255) from attr (i want the exact string not the values)
                let regex = /rgb\((.*?)\)/g
                let match = regex.exec(attr)
                if (match && match.length > 1) {
                    return match[0]
                }
                return null
            }

            function getColorMapping(color) {
                if (!extras.brandKit) {
                    return null
                }
                let reverseMapping = {}
                for (key in extras.brandKit.colors) {
                    let value = extras.brandKit.colors[key]
                    if (key == 'pallete' || key == 'extras') {
                        continue
                    }
                    reverseMapping[value] = key
                }
                if (extras.brandKit.colors.extras) {
                    for (colorKey in extras.brandKit.colors.extras) {
                        let value = extras.brandKit.colors.extras[colorKey]
                        reverseMapping[colorKey] = value
                    }
                }
                let colorMapping = reverseMapping[color]
                if (!colorMapping) {
                    return null
                }
                return colorMapping
            }
            function transformColor(type) {
                // Check if type is object
                if (typeof type == 'object') {
                    let id = type.id
                    let rel = parseFloat(type.rel)
                    let color = extras.pallete[id]
                    if (!color) {
                        return null
                    }
                    return adjustLightness(color, rel*100)
                }
                return extras.pallete[type]
            }

            function transformAttr(attr) {
                if (element.computed[attr]) {
                    let color = extractColor(element.computed[attr])
                    if (color) {
                        let hex = convertToHEX(color)
                        if (hex) {
                            let colorMapping = getColorMapping(hex)
                            if (colorMapping && transformColor(colorMapping)) {
                                style[attr] = style[attr].replace(color, transformColor(colorMapping))
                            }
                        }
                    }
                }
            }

            transformAttr('background')
            transformAttr('color')
            transformAttr('fill')
            transformAttr('stroke')

            // Inline svgs
            if (element.type == 'image' && element.content) {
                // First decide if should replace color (only monochrome)
                // Element.content is a svg string. extract style attrs and all its values
                try {
                    element.content = updateStyleAttributes(element.content);
                } catch (e) {
                    console.error('Error updating style attributes', e)
                }
            }

            if (element.type == 'svg' && element.value) {
                try {
                    element.value = updateStyleAttributes(element.value);
                } catch (e) {
                    console.error('Error updating style attributes', e)
                }
            }

            if (element.type == 'p' && element.value) {
                try {
                    element.value = updateStyleAttributes(element.value);
                } catch (e) {
                    console.error('Error updating style attributes', e)
                }
            }

            let reverseFontMapping = {}
            for (key in extras.brandKit.fonts) {
                let value = extras.brandKit.fonts[key]
                reverseFontMapping[value] = key
            }

            let mapBrandKitAttrs = {
                'body': 'secondary',
                'title': 'primary',
            }

            try {
                if (element.computed['font-family'] && ENABLE_FONT_REPLACEMENT) {
                    let font = element.computed['font-family']
                    let fontMapping = reverseFontMapping[font.replace(/"/g, '')]
                    if (fontMapping && mapBrandKitAttrs[fontMapping]) {
                        let mappedFont = mapBrandKitAttrs[fontMapping]
                        if (extras.fonts[mappedFont]) {
                            style['font-family'] = extras.fonts[mappedFont]
                        }
                    }
                }
            } catch (e) {
                console.error('Error replacing font', e)
            }
        }
        style = replaceCSSAttributes(style, element, extras);

        // Dynamic styles
        if (element.computed) {
            makeSVGClipPathGlobal(element, extras)

            // TODO - Hardcoded (Maybe for title only?)
            delete style.whiteSpace
            delete element.computed['white-space']

            if (element.replace == 'description') {
                style.whiteSpace = 'pre-wrap';
            }

            style = replaceCSSAttributes(style, element.computed, extras, 'all');

            if (style['font-family'] && isDynamicFont(style['font-family'])) {
                // TODO - Load while in styles
                fontsService.loadDynamic(style['font-family'])
            }

            // Fix line height
            if (style['line-height'] && style['font-size']) {
                let lineHeight = parseFloat(style['line-height'])
                let fontSize = parseFloat(style['font-size'])
                // TODO - hardcoded, likely not needed anymore (maybe ignore for mutant)
                if (lineHeight < fontSize * 1.2 && ENSURE_MIN_LINE_HEIGHT) {
                    style['line-height'] = fontSize * 1.2 + 'px'
                }
            }
            // Fix for svg
            if (element.content && element.type == 'image' && !style['line-height']) {
                style['line-height'] = '0px'
            }
            let replaceAttrs = [
                'background',
                'color',
                'fill',
                'stroke'
            ]
            if (element.content || (element.type == 'svg' && element.value) || replaceAttrs.some(attr => element.computed[attr])) {
                if (extras && extras.global && extras.global.applyRotation) {
                    try {
                        applyBrandKit(element, extras)
                    } catch (e) {
                        logError({
                            message: 'Error applying brand kit',
                            error: e
                        })
                    }
                }
            }

            if (element.type == 'image') {
                // TODO - hardcoded, improve rules
                if (style['background']) {
                    if (element?.computed?.['background-size']) {
                        if (!element.computed['background-repeat']) {
                            style['background-repeat'] = 'no-repeat';
                        }
                    } else {
                        style['background-size'] = 'cover';
                        style['background-repeat'] = 'no-repeat';
                        delete style['background-position']
                    }
                }
            }

            // Update color to match transformation
            let enabledRotation = ENABLE_ROTATION && extras && extras.global && extras.global.applyRotation
            if (enabledRotation && extras.originalLayout && extras.originalLayout.transformation && extras.originalLayout.transformation.hue) {
                if (style['color']) {
                    let color = style['color']
                    try {
                        let updatedColor = TransformColor(color, extras.originalLayout.transformation.hue, extras.originalLayout.transformation.saturation)
                        if (updatedColor.indexOf('NaN') == -1) {
                            style['color'] = updatedColor
                        }
                    } catch (e) {
                        logError({
                            message: 'Error transforming color',
                            error: e
                        })
                    }
                }
            }
        } else if (element.type == 'svg' && element.value) {
            try {
                // SVG id conversion
                let svgContent = element.value
                let linearRegex = /id="(.*?)"/g
                let linearMatch = linearRegex.exec(svgContent)

                let ids = []
                while (linearMatch && linearMatch.length > 1) {
                    ids.push(linearMatch[1])
                    linearMatch = linearRegex.exec(svgContent)
                }

                // Replace clip-path ids
                for (let id of ids) {
                    svgContent = svgContent.replaceAll(id, extras.renderedId + '-svg-' + id)
                }
                element.value = svgContent
            } catch (e) {
                console.error('Error converting svg ids', e)
            }
        }

        let updatedValues = {}
        if (VISUAL_ENABLED) {
            let result = applyVisualStyles(element, style, extras, uniqueId)
            style = result.style
            updatedValues = result.updated || {}
        }

        let disableAutoFontSize = extras && extras.custom && typeof extras.custom.autoFontSize === 'boolean' && !extras.custom.autoFontSize && ((window._FEATURES_ && window._FEATURES_.allow_auto_font_size) || FORCE_ENABLE_AUTO_FONT_SIZE)
        const allowedToAutoAdjust = !disableAutoFontSize

        if (style.fontSize && allowedToAutoAdjust) {
            autoShrinkText(style, element, minFontSize)
        }
        let fixedValueHasChanged = element.originalValue && element.originalValue != element.value && element.value

        function calculateLineHeight(style) {
            // TODO - hardcoded
            let finalLineHeight = 1.2
            try {
                if (style['line-height'] && style['line-height'].toString().indexOf('px') == -1) {
                    finalLineHeight = parseFloat(style['line-height'])
                } else {
                    let fontSize = parseFloat(style['font-size'])
                    let lineHeight = parseFloat(style['line-height'])
                    if (lineHeight && fontSize) {
                        finalLineHeight =  lineHeight / fontSize
                    }
                }
            } catch (e) {
                console.error('Error calculating line height', e)
            }

            return finalLineHeight
        }

        let shouldAutoFit = true
        if (updatedValues && updatedValues['font-size']) {
            shouldAutoFit = false
        }

        // Adjust font size for dynamic elements
        if (element.pId && element.value && ['p', 'span', 'h1'].includes(element.type)) {
            // TODO - Review
            if (!element.replacedValue) {
                element.replacedValue = element.value
            }
            element.autoFit = true
            minFontSize = DEFAULT_FONT_MIN_SIZE_FOR_PAINTABLE_TEXTS
        }
        if (element.pId) {
            minFontSize = DEFAULT_FONT_MIN_SIZE_FOR_PAINTABLE_TEXTS
        }
        if ((element.replacedValue || fixedValueHasChanged) && shouldAutoFit && (element.computed || element.autoFit)) {
            let fontFamily = style['font-family'] || style['fontFamily']
            let textStyles = {}
            // set all text styles which may change div bbox
            let relevantStyles = ['font-weight', 'font-style', 'text-transform', 'text-decoration', 'letter-spacing', 'font-size', 'line-height']
            for (let styleKey of relevantStyles) {
                if (style[styleKey]) {
                    textStyles[styleKey] = style[styleKey]
                }
            }
            // Variables and constants
            let proportionLineHeight = calculateLineHeight(style)

            // Change min and max here
            let maxFontSize = remToPx(DEFAULT_FONT_MAX_SIZE)
            let MIN_FONT_SIZE = remToPx(DEFAULT_FONT_MIN_SIZE)
            try {
                maxFontSize = remToPx(style['font-size']) || remToPx(style['fontSize'])
                MIN_FONT_SIZE = remToPx(minFontSize) || remToPx(DEFAULT_FONT_MIN_SIZE)
            } catch (e) {
                console.error('Error parsing font size', e)
            }

            if (DEBUG) {
                console.log('Auto-fitting text for element:', element.id, 'with max font size:', maxFontSize, 'and min font size:', MIN_FONT_SIZE)
            }

            const DEFAULT_MAX_HEIGHT = 200
            let elementParams = {
                fontFamily: fontFamily,
                proportionLineHeight: proportionLineHeight,
                max: maxFontSize,
                textStyles: textStyles
            }

            function applyAdjustedFont({style, size, proportion, oldVisibility}) {
                style['font-size'] = size + 'px';
                style['line-height'] = size * proportion + 'px';
                resetVisibility(style, oldVisibility)
            }
            let shouldAjustFont = element.computed && !!element.computed.height || element.autoFit
            let hasIds = element.id && extras.renderedId

            // Resize to parent (used only for old dynamic layouts, not mutant ones)
            if (element.fitToParent && hasIds) {
                let oldVisibility = style['visibility']
                style['visibility'] = 'hidden'

                fontsService.waitForFont(fontFamily, function(element, style, loaded) {
                    if (!loaded) {
                        resetVisibility(style, oldVisibility)
                        return
                    }
                    // Find element
                    const query = '[data-render-id="' + extras.renderedId + '"] [data-original-id="' + element.id + '"]'
                    waitForQuery(query, function(element, style, domEl) {
                        let parentContainer = domEl.parentElement
                        let parentHeight = parentContainer.clientHeight
                        let parentWidth = parentContainer.clientWidth

                        let othersHeightSum = 0
                        // Get all elements in parent and sum their height (except current element)
                        let elements = parentContainer.children
                        let otherELements = []
                        for (let el of elements) {
                            if (el.attributes['data-original-id'] && el.attributes['data-original-id'].value != element.id) {
                                othersHeightSum += el.clientHeight
                                otherELements.push(el)
                            }
                        }

                        let parentBBox = {
                            width: parentWidth,
                            height: parentHeight - othersHeightSum
                        }

                        // Ajust with parent
                        let adjustedFontSize = adjustFontSizeToFit(element.replacedValue, {
                            width: parentBBox.width,
                            height: parentBBox.height,
                            fontFamily: fontFamily,
                            proportionLineHeight: proportionLineHeight,
                            max: maxFontSize,
                            textStyles: textStyles
                        })

                        // Hide other elements from this box
                        if (adjustedFontSize < MIN_FONT_SIZE) {
                            // Hide others
                            for (let el of otherELements) {
                                el.style.display = 'none'
                            }
                            let adjustedValues = adjustFontWithBBoxAndMinSize(
                                element.replacedValue,
                                {
                                    width: parentBBox.width,
                                    height: parentHeight,
                                },
                                elementParams,
                                MIN_FONT_SIZE,
                                domEl
                            )
                            adjustedFontSize = adjustedValues.size

                            if (element.replacedValue && adjustedValues.value != element.replacedValue) {
                                element.replacedValue = adjustedValues.value
                            }
                        }

                        applyAdjustedFont({style, size: adjustedFontSize, proportion: proportionLineHeight, oldVisibility})
                    }.bind(null, element, style));
                }.bind(null, element, style));
            }
            else if (shouldAjustFont && hasIds && fontFamily && (isDynamicFont(fontFamily) || element.autoFit)) {
                let oldVisibility = style['visibility']
                style['visibility'] = 'hidden'

                let adjustSize = {
                    width: parseFloat(style.width), // TODO - this is wrong (based on %)
                    height: parseFloat(style.height) || parseFloat(style['max-height']) ||  DEFAULT_MAX_HEIGHT
                }

                fontsService.waitForFont(fontFamily, function(element, style, newElement, extras, loaded) {
                    if (!loaded) {
                        resetVisibility(style, oldVisibility)
                        return
                    }
                    const query = '[data-render-id="' + extras.renderedId + '"] [data-original-id="' + element.id + '"]'
                    waitForQuery(query, function(element, style, newElement, extras, domEl) {

                        if (DEBUG) {
                            console.log('Auto-fitting text with max font size:', element.id, maxFontSize, 'and min font size:', MIN_FONT_SIZE)
                        }
                        let adjustedValues = adjustFontWithBBoxAndMinSize(element.replacedValue || element.value, {
                            width: adjustSize.width,
                            height: adjustSize.height,
                        }, elementParams, MIN_FONT_SIZE, domEl)

                        if (element.replacedValue && adjustedValues.value != element.replacedValue) {
                            element.replacedValue = adjustedValues.value
                            if (newElement) {
                                newElement.value = highlightText(adjustedValues.value, extras, element?.pId)
                            }
                        }
                        let adjustedFontSize = adjustedValues.size
                        applyAdjustedFont({style, size: adjustedFontSize, proportion: proportionLineHeight, oldVisibility})
                    }.bind(null, element, style, newElement, extras));
                }.bind(null, element, style, newElement, extras));
            }
        }

        try {
            if (style['font-family'] || style['fontFamily']) {
                let fontName = style['font-family'] || style['fontFamily']
                fontName = fontName.replace(/"/g, '')
                fontsService.loadCustomOrDefault(fontName, function() {

                })
            }
        } catch (e) {
            console.error('Error loading font', e)
        }

        // Font-family fallback
        if (style['font-family'] && style['font-family'].indexOf(',') == -1) {
            style['font-family'] += ', sans-serif'
        }

        return style;
    }

    function makeSVGClipPathGlobal(element, extras) {
        try {
            if (element.type == 'svg' || (element.type == 'image' && element.content)) {
                let svgContent = element.content || element.value
                // Find all clip-path ids
                let clipPaths = []
                let regex = /clip-path="url\(#(.*?)\)"/g
                let match = regex.exec(svgContent)
                while (match && match.length > 1) {
                    clipPaths.push(match[1])
                    match = regex.exec(svgContent)
                }

                // Also matches linearGradient ids
                let linearRegex = /id="(.*?)"/g
                let linearMatch = linearRegex.exec(svgContent)
                while (linearMatch && linearMatch.length > 1) {
                    if (linearMatch[1].startsWith('__id')) {
                        clipPaths.push(linearMatch[1])
                    }
                    linearMatch = linearRegex.exec(svgContent)
                }

                // Replace clip-path ids
                for (let clipPath of clipPaths) {
                    if (!clipPath.startsWith('__id')) {
                        continue
                    }
                    svgContent = svgContent.replaceAll(clipPath, extras.renderedId + '-svg-' + clipPath)
                }
                if (element.type == 'svg') {
                    element.value = svgContent
                } else {
                    element.content = svgContent
                }
            }
        } catch (e) {
            console.error('Error updating clip-path', e)
        }
    }

    function waitForQuery(query, cb) {
        let domEl = document.querySelector(query)
        if (domEl) {
            cb(domEl)
        } else {
            setTimeout(waitForQuery.bind(null, query, cb), 50)
        }
    }

    function adjustFontWithBBox(value, bbox, params) {
        return adjustFontSizeToFit(value, {
            width: bbox.width,
            height: bbox.height,
            fontFamily: params.fontFamily,
            proportionLineHeight: params.proportionLineHeight,
            max: params.max,
            textStyles: params.textStyles
        })
    }

    function adjustFontWithBBoxAndMinSize(value, bbox, params, minSize, domEl) {
        let lessThanMin = false

        try {
            value = convertFontSizesToEm(value)
        } catch (e) {
            console.error('Error converting font sizes to em', e)
        }
        try {
            value = autoHyphenate(value)
        } catch (e) {
            console.error('Error auto-hyphenating text', e)
        }
        if (DEBUG) {
            console.log('adjustFontWithBBoxAndMinSize', value, bbox, params, minSize)
        }
        let adjustedFontSize = adjustFontWithBBox(value, bbox, params)
        if (adjustedFontSize < minSize && domEl.children.length > 0) {
            lessThanMin = true
            let firstChild = domEl.children[0]
            let valuesToTry = ['4rem', '2rem']
            let originalValue = value
            // TODO - Hardcoded
            if (firstChild && firstChild.style.fontSize == TITLE_HIGHLIGHT_SIZE) {
                let currentValue = value
                let currentChildFontSize = null
                for (let valueToTry of valuesToTry) {
                    // TODO - hardcoded
                    currentValue = originalValue.replace(TITLE_HIGHLIGHT_SIZE, valueToTry)
                    adjustedFontSize = adjustFontWithBBox(currentValue, bbox, params)
                    if (adjustedFontSize >= minSize) {
                        value = currentValue
                        currentChildFontSize = valueToTry
                        break
                    }
                }
                if (!currentChildFontSize) {
                    currentChildFontSize = valuesToTry[valuesToTry.length - 1]
                    value = currentValue
                }
                firstChild.style.fontSize = currentChildFontSize
            }
        }
        if (adjustedFontSize < minSize) {
            if (DEBUG) {
                console.log('Adjusted font size less than min size, setting to min size', adjustedFontSize, minSize)
            }
            adjustedFontSize = minSize
        }
        return {
            size: adjustedFontSize,
            value: value,
            adjustedMin: lessThanMin
        }
    }

    function applyPropertiesToValue(element, extras) {
        let value = element.value;

        function replaceFillColor(props) {
            let replacedColor = replaceColor(props['fill'], extras.pallete);

            let patterns = [
                'fill="([^"]*)"',
                "fill='([^']*)'",
                'stroke="([^"]*)"',
                "stroke='([^']*)'"
            ]
            for (let pattern of patterns) {
                value = value.replace(new RegExp(pattern, 'g'), function(match, p1) {
                    if (p1 == 'none') {
                        return match
                    }
                    return match.replace(p1, replacedColor)
                })
            }
            return value.replace(new RegExp('<svg', 'g'), '<svg fill="' + replacedColor + '"');
        }
        try {
            if (element.type != 'overlay') {
                return element.value
            }
            if (element.fill) {
                value = replaceFillColor(element)
            }
            if (!extras || !extras.custom || !extras.custom.visual || !extras.custom.visual.elements || !extras.custom.visual.elements[element.uniqueId]) {
                return value
            }
            let props = extras.custom.visual.elements[element.uniqueId]
            if (props['fill']) {
                value = replaceFillColor(props)
            }
        } catch (e) {
            logError({
                message: 'Error applying properties to value',
                error: e
            })
        }
        return value
    }

    function applyVisualStyles(element, style, extras, uniqueId) {
        let updated = {}
        try {
            if (!uniqueId || !extras || !extras.custom || !extras.custom.visual || !extras.custom.visual.elements || !extras.custom.visual.elements[uniqueId]) {
                return {
                    style,
                    updated
                }
            }
            let props = extras.custom.visual.elements[uniqueId]
            // Available props
            style.transform = ''
            for (let prop of visualAvailableProps) {
                if (typeof props[prop] != 'undefined') {
                    if (prop == 'z-index') {
                        style.zIndex = props[prop]
                        updated[prop] = props[prop]
                        continue
                    }
                    let camelCaseProp = prop.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
                    delete style[camelCaseProp]
                    style[prop] = props[prop]
                    updated[prop] = props[prop]
                }

                if (props['font-family']) {
                    fontsService.load([props['font-family']])
                }
            }
            if (props.translate) {
                style.transform += `translate(${props.translate.x}px, ${props.translate.y}px)`
                updated.translate = props.translate
            }
            if (props.scale) {
                style.transform += ` scale(${props.scale})`
                updated.scale = props.scale
            }
        } catch (e) {
            logError({
                message: 'Error applying visual styles',
                error: e
            })
        }
        return {
            style,
            updated
        }
    }

    return {
        generate: generate,
        applyPropertiesToValue: applyPropertiesToValue,
        highlightText: highlightText,
        replaceColor: replaceColor,
    }
});
